import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../config/api';

const POLL_INTERVAL_MS = 2 * 60 * 1000;

/**
 * Polls unread inquiry message counts for traveler or partner chrome badges.
 * @param {{ enabled?: boolean, viewer?: 'traveler' | 'partner' }} options
 */
const useInquiryUnreadCount = ({ enabled = true, viewer = 'traveler' } = {}) => {
  const location = useLocation();
  const [unread, setUnread] = useState(0);

  const fetchUnread = useCallback(async () => {
    if (!enabled) {
      setUnread(0);
      return;
    }
    try {
      const path = viewer === 'partner'
        ? '/package-booking/partner/inquiries/unread-count'
        : '/package-booking/my-inquiries/unread-count';
      const response = await api.get(path);
      setUnread(Number(response.data?.unread || 0));
    } catch (err) {
      // Badge failures should stay silent.
    }
  }, [enabled, viewer]);

  useEffect(() => {
    fetchUnread();
    if (!enabled) return undefined;

    const timer = setInterval(fetchUnread, POLL_INTERVAL_MS);
    const onFocus = () => fetchUnread();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', onFocus);
    };
  }, [enabled, fetchUnread, location.pathname]);

  return unread;
};

export default useInquiryUnreadCount;
